import _ from 'lodash'
import { Base64 } from 'js-base64'
import { decodeLanguages } from '@/views/creative/utils/i18n'
import emptyHiddenI18nFields from '@/store/creative/common/empty-hidden-i18n-fields'
import { gameDifficultyCategoryConfig } from '@/store/creative/common/category'
import { isMultiGameDifficulty } from '@/views/creative/utils'

export default function cookPackedGroupsConfig({
  groupsConfig,
  previewLanguageList,
  i18nResource,
  jsonConfig,
  gameConfigResource,
  category,
}) {
  const cloneI18nResource = _.cloneDeep(i18nResource)
  let cloneGroupsConfig = _.cloneDeep(groupsConfig)
  const cloneGameConfigResource = _.cloneDeep(gameConfigResource)
  jsonConfig = _.cloneDeep(jsonConfig)
  category = _.cloneDeep(category)

  /**
   * 组装组合的代码字
   * @param group {{}}
   * @returns {{languages: null|{}, fallbackLocale: undefined}}
   */
  const cookI18nForGroup = ({ group }) => {
    const i18n = {
      ..._.get(jsonConfig, 'i18n', {}),
      // fallbackLocale 与 languages 可能被修改了，所以需要重新加工，其他属性不变
      // 如 textConfig、selfDevToPs（从通用模板转自由编辑保存后的素材或模板就有 textConfig、selfDevToPs 数据）
      fallbackLocale: _.get(jsonConfig, 'i18n.fallbackLocale'),
      languages: null,
    }
    // 组合语言 + 非组合语言 + 通用语言
    const i18nList = _.get(group, 'i18n.list')
    let languages = {}

    previewLanguageList.forEach((lang) => {
      // 单个组合坑位
      _.each(cloneI18nResource, (i18nItem) => {
        _.set(
          languages,
          `${lang}.${Base64.encode(i18nItem[0].prefix)}`,
          i18nItem[0].data[lang],
        )
      })

      // 多个组合坑位
      i18nList &&
        i18nList.forEach((i18nItem) => {
          _.set(
            languages,
            `${lang}.${Base64.encode(i18nItem.prefix)}`,
            cloneI18nResource[Base64.encode(i18nItem.prefix)].find(
              (item) => item.id === i18nItem.id,
            ).data[lang],
          )
        })
    })

    languages = decodeLanguages(languages)

    const decodedLanguages = decodeLanguages(
      _.get(jsonConfig, 'i18n.languages'),
    )
    // 兼容代码字所有属性都没有归属的场景
    if (_.isEmpty(languages)) {
      languages = { ...decodedLanguages }
    } else {
      _.each(languages, (i18nItem, key) => {
        languages[key] = {
          ..._.get(decodedLanguages, `${key}`),
          ...i18nItem,
        }
      })
    }

    i18n.languages = languages

    return i18n
  }

  /**
   * 组装组的玩法配置
   * @param group {{}}
   * @returns {{gameConfig}}
   */
  const cookGameConfigForGroup = ({ group }) => {
    const gameConfigList = _.get(group, 'game_config.list')
    let gameConfig = {}

    // 先拿坑位的第一个配置的值
    cloneGameConfigResource &&
      _.each(cloneGameConfigResource, (gameConfigItem) => {
        const prefix = gameConfigItem[0].prefix
        gameConfig[prefix] = gameConfigItem[0].data
      })

    // 查看一下当前 game_config.list 是否有值，如果有找到其在对应坑位的值，找不到就还是使用第一个配置的值
    gameConfigList &&
      gameConfigList.forEach((gameConfigItem) => {
        if (!isMultiGameDifficulty(gameConfigItem.prefix)) {
          gameConfig[gameConfigItem.prefix] = cloneGameConfigResource[
            gameConfigItem.prefix
          ].find((item) => item.id === gameConfigItem.id).data
        }
      })

    // 难度模式坑位单独处理（将难度模式里的内容拍平处理）
    const gameDifficultyList = _.get(
      cloneGameConfigResource,
      'gameDifficultyList',
    )
    if (_.isArray(gameDifficultyList)) {
      // 只有一个的场景
      if (gameDifficultyList.length === 1) {
        gameConfig = {
          ...gameConfig,
          ...gameDifficultyList[0].data,
        }
      } else {
        // 多个难度
        gameConfigList &&
          gameConfigList.forEach((gameConfigItem) => {
            if (isMultiGameDifficulty(gameConfigItem.prefix)) {
              gameConfig = {
                ...gameConfig,
                ...gameDifficultyList.find(
                  (item) => item.id === gameConfigItem.id,
                ).data,
              }
            }
          })
      }
    }

    const newGameConfig = {
      ...jsonConfig,
      gameConfig: {
        ...jsonConfig.gameConfig,
        // 过滤掉难度模式数据,因为已经将当前难度下的玩法提取到 gameConfig 中了，不过滤的话会导致 gameConfig 多了
        // easyGameDifficulty、mediumGameDifficulty或hardGameDifficulty的属性数据
        ..._.omit(
          gameConfig,
          Object.values(gameDifficultyCategoryConfig).map(
            (item) => item.prefix,
          ),
        ),
      },
    }

    // playable 要求 autoEndTime/playAgain 必须是 number 类型
    if (!_.isUndefined(newGameConfig.autoEndTime)) {
      newGameConfig.autoEndTime = Number(newGameConfig.autoEndTime)
    }
    if (!_.isUndefined(newGameConfig.playAgain)) {
      newGameConfig.playAgain = Number(newGameConfig.playAgain)
    }

    delete newGameConfig.i18n
    return newGameConfig
  }

  cloneGroupsConfig = cloneGroupsConfig.map((groupItem) => {
    groupItem.game_config.data = cookGameConfigForGroup({ group: groupItem })

    if (_.get(jsonConfig, 'i18n.languages')) {
      const i18n = cookI18nForGroup({ group: groupItem })
      groupItem.i18n.data = i18n
      groupItem.i18n.packData = emptyHiddenI18nFields(i18n, category)
    }

    return groupItem
  })

  return cloneGroupsConfig
}
